
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2skXt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PolarisUnlicensedPage", () => $53aae0483fcd1ea2$export$36f29bd38aa5c37c);
$parcel$export(module.exports, "default", () => $53aae0483fcd1ea2$export$2e2bcd8739ae039);
parcelRequire("kQSGw");

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $9J4DQ = parcelRequire("9J4DQ");

var $kJlBc = parcelRequire("kJlBc");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $6M8Uw = parcelRequire("6M8Uw");

var $iJHZm = parcelRequire("iJHZm");
const $53aae0483fcd1ea2$var$PolarisUnlicensedPageContentInternal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J4DQ.default), null);
const $53aae0483fcd1ea2$var$PolarisUnlicensedPageContent = /*#__PURE__*/ (0, $eUqFw.memo)($53aae0483fcd1ea2$var$PolarisUnlicensedPageContentInternal);
const $53aae0483fcd1ea2$export$36f29bd38aa5c37c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "polaris-unlicensed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "polaris"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53aae0483fcd1ea2$var$PolarisUnlicensedPageContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null))));
var $53aae0483fcd1ea2$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)($53aae0483fcd1ea2$export$36f29bd38aa5c37c);

});
parcelRegister("9J4DQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7369fb422e438ecc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");

var $7rkuz = parcelRequire("7rkuz");
const $7369fb422e438ecc$export$491740e76e0144c9 = ()=>{
    const [beta] = (0, $kJlBc.useQueryParam)('beta');
    const [returnTo] = (0, $kJlBc.useQueryParam)('returnTo');
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [isBeta, setIsBeta] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setLoading(true);
        (0, $2OdyW.default)('/rest/polaris/edition').then((editionMetaResponse)=>{
            if (beta && !editionMetaResponse?.beta) window.location.href = returnTo?.startsWith('/jira/polaris/projects/') ? returnTo : '/jira/your-work';
            else {
                setIsBeta(editionMetaResponse?.beta);
                setLoading(false);
            }
        }).catch(()=>{
            setLoading(false);
        });
    }, [
        beta,
        returnTo
    ]);
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isBeta: isBeta
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "JpdUnlicensedApp loaded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rkuz.LicenseFail), null));
};
var $7369fb422e438ecc$export$2e2bcd8739ae039 = $7369fb422e438ecc$export$491740e76e0144c9;

});
parcelRegister("7rkuz", function(module, exports) {

$parcel$export(module.exports, "LicenseFail", () => $73c8cbaa5c4d4cf6$export$61072fd9f5755c54);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $lkO3b = parcelRequire("lkO3b");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4KJox = parcelRequire("4KJox");

var $1h3Sb = parcelRequire("1h3Sb");

var $8WuJm = parcelRequire("8WuJm");

var $kJlBc = parcelRequire("kJlBc");

var $gd0Sp = parcelRequire("gd0Sp");

var $hZ6X5 = parcelRequire("hZ6X5");

var $oQZY6 = parcelRequire("oQZY6");

var $5Rv4n = parcelRequire("5Rv4n");
const $73c8cbaa5c4d4cf6$var$COMMUNITY = 'https://community.atlassian.com/t5/Jira-Product-Discovery-articles/How-to-move-from-beta-to-the-Free-or-Standard-plans-of-Jira/ba-p/2355268';
const $73c8cbaa5c4d4cf6$var$PLAN = '/admin/billing-preview?referrerName=JIRA';
const $73c8cbaa5c4d4cf6$export$129cded5591707fe = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { success: success, error: error } = (0, $1h3Sb.useNotifications)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onOpenDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $5Rv4n.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$var$LogoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkO3b.JiraProductDiscoveryLogo), {
        size: "xlarge",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        width: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hZ6X5))),
        imageWidth: 210,
        header: formatMessage((0, $5Rv4n.default).betaHeader),
        description: formatMessage((0, $5Rv4n.default).betaDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: $73c8cbaa5c4d4cf6$var$PLAN,
            target: "_blank",
            appearance: "primary"
        }, formatMessage((0, $5Rv4n.default).managePlan)),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onOpenDialog
        }, formatMessage((0, $5Rv4n.default).contactSupport)),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: $73c8cbaa5c4d4cf6$var$COMMUNITY,
            appearance: "link",
            target: "_blank"
        }, formatMessage((0, $5Rv4n.default).learnMore))
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4KJox.default), {
        onCancel: onCloseDialog,
        defaultCategoryName: "help",
        onSuccess: success,
        onError: error
    }));
};
const $73c8cbaa5c4d4cf6$export$af9df59a8b41e894 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $5Rv4n.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$var$LogoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkO3b.JiraProductDiscoveryLogo), {
        size: "xlarge",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        width: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hZ6X5))),
        imageWidth: 210,
        header: formatMessage((0, $5Rv4n.default).betaHeader),
        description: formatMessage((0, $5Rv4n.default).betaDescriptionNonAdmin),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: $73c8cbaa5c4d4cf6$var$COMMUNITY,
            appearance: "link",
            target: "_blank"
        }, formatMessage((0, $5Rv4n.default).learnMore))
    }));
};
const $73c8cbaa5c4d4cf6$var$EndOfBetaPage = ()=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    if (isSiteAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$export$129cded5591707fe, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$export$af9df59a8b41e894, null);
};
const $73c8cbaa5c4d4cf6$export$90aeedf5355affcf = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $5Rv4n.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        width: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($oQZY6))),
        header: formatMessage((0, $5Rv4n.default).header),
        description: formatMessage((0, $5Rv4n.default).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
            to: "/jira/projects"
        }, formatMessage((0, $5Rv4n.default).action))
    }));
};
const $73c8cbaa5c4d4cf6$export$61072fd9f5755c54 = ()=>{
    const [beta] = (0, $kJlBc.useQueryParam)('beta');
    if (beta) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "polarisEndOfBetaScreen",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$var$EndOfBetaPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "polarisUnlicensedScreen",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73c8cbaa5c4d4cf6$export$90aeedf5355affcf, null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73c8cbaa5c4d4cf6$var$LogoContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk16xz _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("4KJox", function(module, exports) {

$parcel$export(module.exports, "default", () => $216b305903d9fe53$export$2e2bcd8739ae039);

var $cjgoS = parcelRequire("cjgoS");
var $216b305903d9fe53$export$2e2bcd8739ae039 = (0, $cjgoS.default);

});
parcelRegister("cjgoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45f32b2d5359a73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4vjkK = parcelRequire("4vjkK");

var $kzv8t = parcelRequire("kzv8t");

var $4Vf1i = parcelRequire("4Vf1i");

var $64BFt = parcelRequire("64BFt");

var $fCHT3 = parcelRequire("fCHT3");

var $3Gbiy = parcelRequire("3Gbiy");
const $e45f32b2d5359a73$var$templateOptions = {
    feedback: {
        key: 'feedback',
        title: (0, $fCHT3.default).title,
        selectLabel: (0, $fCHT3.default).feedbackOptionLabel,
        target: (0, $3Gbiy.FeedbackCategory).CustomerFeedback,
        template: (msg)=>msg
    },
    help: {
        key: 'help',
        title: (0, $fCHT3.default).title,
        selectLabel: (0, $fCHT3.default).helpOptionLabel,
        target: (0, $3Gbiy.FeedbackCategory).GetSupportAtlassianCom,
        template: (msg)=>msg
    }
};
const $e45f32b2d5359a73$var$templatesKeys = Object.keys($e45f32b2d5359a73$var$templateOptions);
const $e45f32b2d5359a73$export$5efdacda4e928df9 = ({ onCancel: onCancel, defaultCategoryName: defaultCategoryName = 'feedback', onSuccess: onSuccess, onError: onError, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [successMessage, errorMessage] = (0, $4Vf1i.getFlagContent)(formatMessage);
    const selectOptions = $e45f32b2d5359a73$var$templatesKeys.map((key)=>({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: formatMessage($e45f32b2d5359a73$var$templateOptions[key].selectLabel),
            value: key
        }));
    const defaultTemplate = $e45f32b2d5359a73$var$templateOptions[defaultCategoryName] || $e45f32b2d5359a73$var$templateOptions.feedback;
    const [selectedTemplate, setSelectedTemplate] = (0, $eUqFw.useState)(defaultTemplate);
    const [title, setTitle] = (0, $eUqFw.useState)(defaultTemplate.title);
    const [message, setMessage] = (0, $eUqFw.useState)('');
    const [transmitting, setTransmitting] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setTitle(selectedTemplate.title);
    }, [
        selectedTemplate
    ]);
    const onOptionChange = (item)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setSelectedTemplate($e45f32b2d5359a73$var$templateOptions[item?.value] || defaultTemplate);
    };
    const onSubmit = async ()=>{
        const { target: target } = selectedTemplate;
        const templatedMessage = selectedTemplate.template(message);
        setTransmitting(true);
        await (0, $4vjkK.raiseTicket)(templatedMessage, target).then(()=>{
            onSuccess(successMessage);
            onCancel();
        }).catch(()=>onError(errorMessage));
        setTransmitting(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onCancel,
        width: "450px",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage(title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzv8t.Content), {
        message: message,
        sectionMessage: selectedTemplate.sectionMessage,
        setMessage: setMessage,
        onCategoryChange: onOptionChange,
        feedbackCategories: selectOptions,
        selectedCategory: {
            label: formatMessage(selectedTemplate.selectLabel),
            value: selectedTemplate.key
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64BFt.Footer), {
        isDisabled: !message || transmitting,
        onSubmit: onSubmit,
        onCancel: onCancel,
        transmitting: transmitting
    }))));
};
var $e45f32b2d5359a73$export$2e2bcd8739ae039 = $e45f32b2d5359a73$export$5efdacda4e928df9;

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("4vjkK", function(module, exports) {

$parcel$export(module.exports, "raiseTicket", () => $8fabe090233e3775$export$b5bee6372ba7b7d6);

var $lRmyA = parcelRequire("lRmyA");
const $8fabe090233e3775$var$PROXY_URL = '/gateway/api/jpd/proxy/v1/feedback';
const $8fabe090233e3775$export$b5bee6372ba7b7d6 = (message, target)=>(0, $lRmyA.performPostRequest)($8fabe090233e3775$var$PROXY_URL, {
        body: JSON.stringify({
            message: message,
            target: target
        })
    });

});

parcelRegister("kzv8t", function(module, exports) {

$parcel$export(module.exports, "Content", () => $bb64bc95d463dfa8$export$7c6e2c02157bb7d2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $4LhB6 = parcelRequire("4LhB6");

var $2bv8J = parcelRequire("2bv8J");

var $lfiOu = parcelRequire("lfiOu");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $5wCDk = parcelRequire("5wCDk");

var $xeS7R = parcelRequire("xeS7R");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2eePP = parcelRequire("2eePP");
const $bb64bc95d463dfa8$export$7c6e2c02157bb7d2 = ({ feedbackCategories: feedbackCategories, onCategoryChange: onCategoryChange, selectedCategory: selectedCategory, message: message, sectionMessage: sectionMessage, setMessage: setMessage })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb64bc95d463dfa8$var$FeedbackWarningContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        size: "medium",
        primaryColor: (0, $PdmhA.B400)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb64bc95d463dfa8$var$FeedbackWarningTextHintContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage((0, $2eePP.default).feedbackWarning, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: "https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd",
                    target: "_blank",
                    tabIndex: -1
                }, children)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $2eePP.default).categoryPickerLabel),
        name: "feedback-category-selection"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            spacing: "compact",
            isClearable: false,
            defaultValue: selectedCategory,
            options: feedbackCategories,
            onChange: onCategoryChange,
            menuPortalTarget: document.body,
            styles: {
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    }),
                menu: (base)=>({
                        ...base,
                        zIndex: 99
                    })
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default // @ts-expect-error: Element implicitly has an 'any' type because expression of type '`${string}TextAreaLabel` | `${number}TextAreaLabel`'
    ), {
        label: formatMessage((0, $2eePP.default)[`${selectedCategory.value}TextAreaLabel`]),
        isRequired: true,
        name: "feedback-body"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
            ...fieldProps,
            id: "feedback-body",
            isRequired: true,
            value: message,
            resize: "none",
            minimumRows: 5,
            onChange: (event)=>{
                setMessage(event.currentTarget.value);
            }
        })), sectionMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bb64bc95d463dfa8$var$sectionMessageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, formatMessage(sectionMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb64bc95d463dfa8$var$StyledCheckbox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: true,
        isDisabled: true,
        label: formatMessage((0, $2eePP.default).allowContactingLabel),
        name: "allow-contacting-checkbox"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb64bc95d463dfa8$var$StyledCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8dt3i",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb64bc95d463dfa8$var$FeedbackWarningContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb64bc95d463dfa8$var$FeedbackWarningTextHintContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _vwz41tcg _18u01b66",
            __cmplp.className
        ])
    });
});
const $bb64bc95d463dfa8$var$sectionMessageContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $6XgOP.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

var $PdmhA = parcelRequire("PdmhA");
const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $PdmhA.N40)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $PdmhA.R400)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $PdmhA.N100)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $PdmhA.B200)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $PdmhA.N10)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $PdmhA.N70)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("2eePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b6a19870b70301$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2b6a19870b70301$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedbackWarning: {
        "id": "polaris-lib-feedback.modal.content.feedback-warning",
        "defaultMessage": "Visit our {linkStart}community{linkEnd} to learn tips, best practices and FAQ."
    },
    categoryPickerLabel: {
        "id": "polaris-lib-feedback.modal.content.category-picker-label",
        "defaultMessage": "I want to..."
    },
    allowContactingLabel: {
        "id": "polaris-lib-feedback.modal.content.allow-contacting-label",
        "defaultMessage": "Atlassian can contact me about this feedback"
    },
    helpTextAreaLabel: {
        "id": "polaris-lib-feedback.modal.content.help-text-area-label",
        "defaultMessage": "What can we help with?"
    },
    feedbackTextAreaLabel: {
        "id": "polaris-lib-feedback.modal.content.feedback-text-area-label",
        "defaultMessage": "Let us know what's on your mind"
    },
    betaExtensionTextAreaLabel: {
        "id": "polaris-lib-feedback.modal.content.beta-extension-text-area-label",
        "defaultMessage": "Let us know your reason for requesting an extension"
    }
});

});


parcelRegister("4Vf1i", function(module, exports) {

$parcel$export(module.exports, "getFlagContent", () => $72c1fb81b1705a36$export$7d2d484057868ff7);

var $1ZUJN = parcelRequire("1ZUJN");
const $72c1fb81b1705a36$var$SUCCESS_FLAG_CONFIG = {
    type: 'success',
    title: (0, $1ZUJN.default).successFlagTitle,
    description: (0, $1ZUJN.default).successFlagDescription,
    action: {
        content: (0, $1ZUJN.default).joinCommunity,
        href: 'https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd',
        target: '_blank'
    },
    isAutoDismiss: false
};
const $72c1fb81b1705a36$var$ERROR_FLAG_CONFIG = {
    type: 'error',
    title: (0, $1ZUJN.default).errorFlagTitle,
    description: (0, $1ZUJN.default).errorFlagDescription,
    action: {
        content: (0, $1ZUJN.default).getHelp,
        href: 'https://support.atlassian.com/',
        target: '_blank'
    },
    isAutoDismiss: false
};
const $72c1fb81b1705a36$export$7d2d484057868ff7 = (formatMessage)=>[
        $72c1fb81b1705a36$var$SUCCESS_FLAG_CONFIG,
        $72c1fb81b1705a36$var$ERROR_FLAG_CONFIG
    ].map((flagConfig)=>({
            title: formatMessage(flagConfig.title),
            description: formatMessage(flagConfig.description),
            actions: [
                {
                    ...flagConfig.action,
                    content: formatMessage(flagConfig.action.content)
                }
            ],
            isAutoDismiss: flagConfig.isAutoDismiss
        }));

});
parcelRegister("1ZUJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd6a06d654173fa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ddd6a06d654173fa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    successFlagTitle: {
        "id": "polaris-lib-feedback.modal.flags.success-flag-title",
        "defaultMessage": "Thank you for your feedback"
    },
    successFlagDescription: {
        "id": "polaris-lib-feedback.modal.flags.success-flag-description",
        "defaultMessage": "Join the Jira Product Discovery community group to discuss product improvements and get more help."
    },
    joinCommunity: {
        "id": "polaris-lib-feedback.modal.flags.join-community",
        "defaultMessage": "Join the community"
    },
    errorFlagTitle: {
        "id": "polaris-lib-feedback.modal.flags.error-flag-title",
        "defaultMessage": "We couldn\u2019t submit your feedback"
    },
    errorFlagDescription: {
        "id": "polaris-lib-feedback.modal.flags.error-flag-description",
        "defaultMessage": "Check your internet connection and try submitting your feedback again."
    },
    getHelp: {
        "id": "polaris-lib-feedback.modal.flags.get-help",
        "defaultMessage": "Get help"
    }
});

});


parcelRegister("64BFt", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $4e2dd15456cee180$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2OJfS = parcelRequire("2OJfS");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dSFNA = parcelRequire("dSFNA");
const $4e2dd15456cee180$export$a06f1c675e846f6f = ({ isDisabled: isDisabled, onSubmit: onSubmit, onCancel: onCancel, transmitting: transmitting, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: isDisabled,
        appearance: "primary",
        onClick: onSubmit
    }, transmitting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e2dd15456cee180$var$StyledSpinner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: testId
    })), formatMessage((0, $dSFNA.default).sendFeedback)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: transmitting,
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $dSFNA.default).cancel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2dd15456cee180$var$StyledSpinner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dSFNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8ae1f3828ed1f6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2b8ae1f3828ed1f6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cancel: {
        "id": "polaris-lib-feedback.modal.footer.cancel",
        "defaultMessage": "Cancel"
    },
    sendFeedback: {
        "id": "polaris-lib-feedback.modal.footer.send-feedback",
        "defaultMessage": "Send feedback"
    }
});

});


parcelRegister("fCHT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64b3e89cc7d3e0a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c64b3e89cc7d3e0a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "polaris-lib-feedback.modal.title",
        "defaultMessage": "Share your thoughts"
    },
    feedbackOptionLabel: {
        "id": "polaris-lib-feedback.modal.feedback-option-label",
        "defaultMessage": "Submit feedback to the product team"
    },
    helpOptionLabel: {
        "id": "polaris-lib-feedback.modal.help-option-label",
        "defaultMessage": "Get help from the support team"
    }
});

});

parcelRegister("3Gbiy", function(module, exports) {

$parcel$export(module.exports, "FeedbackCategory", () => $bc7cd3763ae2308c$export$9603bd92c0a685ab);
var $bc7cd3763ae2308c$export$9603bd92c0a685ab;
(function(FeedbackCategory) {
    FeedbackCategory["CustomerFeedback"] = "CF";
    FeedbackCategory["GetSupportAtlassianCom"] = "GSAC";
})($bc7cd3763ae2308c$export$9603bd92c0a685ab || ($bc7cd3763ae2308c$export$9603bd92c0a685ab = {}));

});



parcelRegister("1h3Sb", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $ddec6a7ee902efc4$export$53d5ca6c3f53e109);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $eBkd9 = parcelRequire("eBkd9");
var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");
const $ddec6a7ee902efc4$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props
            })
    };
};
const $ddec6a7ee902efc4$var$customFlag = (notification, onDismiss)=>$ddec6a7ee902efc4$var$customFlagCommon(notification, onDismiss, (0, $cCFSU.default));
const $ddec6a7ee902efc4$var$customAutoDismissFlag = (notification, onDismiss)=>$ddec6a7ee902efc4$var$customFlagCommon(notification, onDismiss, (0, $eBkd9.default));
const $ddec6a7ee902efc4$var$success = (notification, onDismiss)=>$ddec6a7ee902efc4$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            label: "Success icon",
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G300})`
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success'
    }, onDismiss);
const $ddec6a7ee902efc4$var$errorWithRefresh = (notification, onDismiss)=>$ddec6a7ee902efc4$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "Error",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh'
    }, onDismiss);
const $ddec6a7ee902efc4$var$error = (notification, onDismiss)=>$ddec6a7ee902efc4$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "Error",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error'
    }, onDismiss);
const $ddec6a7ee902efc4$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($ddec6a7ee902efc4$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($ddec6a7ee902efc4$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($ddec6a7ee902efc4$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($ddec6a7ee902efc4$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
                const flagId = showFlag({
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("eBkd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2abc675c3cd85b60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $2abc675c3cd85b60$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $2abc675c3cd85b60$export$2e2bcd8739ae039 = $2abc675c3cd85b60$var$AkAutoDismissFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>{
    if ((0, $1ybV0.ff)('post-office_enable_jira_choreographer')) return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hZ6X5", function(module, exports) {
module.exports = new URL("heros.d5da5dcf.svg", import.meta.url).toString();

});

parcelRegister("oQZY6", function(module, exports) {
module.exports = new URL("magnifying_glass_error.cbb1b3dd.svg", import.meta.url).toString();

});

parcelRegister("5Rv4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6ded7d87d2161f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b6ded7d87d2161f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitle: {
        "id": "polaris-apps-unlicensed.page-title",
        "defaultMessage": "Jira Product Discovery"
    },
    header: {
        "id": "polaris-apps-unlicensed.header",
        "defaultMessage": "Jira Product Discovery has been deactivated"
    },
    description: {
        "id": "polaris-apps-unlicensed.description",
        "defaultMessage": "Please contact your site administrator to reactivate Jira Product Discovery and regain access."
    },
    action: {
        "id": "polaris-apps-unlicensed.action",
        "defaultMessage": "View a list of all projects"
    },
    betaHeader: {
        "id": "polaris-apps-unlicensed.beta-header",
        "defaultMessage": "Select a Free or Standard plan to get access"
    },
    betaDescription: {
        "id": "polaris-apps-unlicensed.beta-description",
        "defaultMessage": "The Beta edition is no longer available. We are grateful for all the feedback you've provided during our beta period, which has helped us shape the product into what it is today. To continue using Jira Product Discovery, please update your plan to Free or Standard. Moving to the Standard edition starts a free 14 day trial, you can use this time to request an annual quote if required."
    },
    betaDescriptionNonAdmin: {
        "id": "polaris-apps-unlicensed.beta-description-non-admin",
        "defaultMessage": "The Beta plan is no longer available. To continue using Jira Product Discovery, please contact your site admin to update the plan to Free or Standard."
    },
    contactSupport: {
        "id": "polaris-apps-unlicensed.contact-support",
        "defaultMessage": "Contact support"
    },
    managePlan: {
        "id": "polaris-apps-unlicensed.manage-plan",
        "defaultMessage": "Manage plan"
    },
    learnMore: {
        "id": "polaris-apps-unlicensed.learn-more",
        "defaultMessage": "Check out our detailed instructions to regain access."
    }
});

});



parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});



//# sourceMappingURL=async-polaris-unlicensed.ba2f1763.js.map
